export default __webpack_public_path__ + "9b009a12b0c860fdab707dc957832814.svg";